import dayjs from "dayjs";
import "dayjs/locale/ro";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const DEFAULT_DATE_FORMAT = "DD.MM.YYYY";

export default {
  install(Vue, config) {
    Vue.formatDate = (date, options) => {
      const lang = config.lang();
      return formatDate(date, options, lang);
    };

    Vue.prototype.$formatDate = function(date, options) {
      const lang = config.lang();
      return formatDate(date, options, lang);
    };

    Vue.prototype.$humanizeDate = function(date) {
      const lang = config.lang();
      return humanizeDate(date, lang);
    };

    Vue.mixin({
      filters: {
        date(date, options) {
          const lang = config.lang();
          return formatDate(date, options, lang);
        },

        humanizeDate(date) {
          const lang = config.lang();
          return humanizeDate(date, lang);
        },
      },
    });
  },
};

function humanizeDate(date, lang) {
  dayjs.locale(lang);

  return dayjs(date).fromNow();
}

function formatDate(date, options, lang) {
  dayjs.locale(lang);

  const defaultOptions = {
    format: DEFAULT_DATE_FORMAT,
    default: "-",
  };

  options = Object.assign(defaultOptions, options);
  if (!date) {
    return options.default;
  }

  return dayjs(date).format(options.format);
}
